module.exports = __webpack_public_path__ + "static/media/Important Rules.56cacf9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/driverpolicy-images/Important Rules.png
// module id = 1283
// module chunks = 0